import React, {useEffect} from 'react'
import { Link } from 'react-router-dom';
import LocalizedText from '../../presentational/LocalizedText';
import useTranslate from "../../../hooks/useTranslate";
import Input from "../../presentational/Input";
import Button from "../../presentational/Button";
import { isValidEmailOrPhone } from '../utils'
import './Join.css'
import {
  ClientError,
  LoginLink
} from '../types';
import { useTurnstile } from "../../../hooks/useTurnstile";

interface JoinParameters {
  emailOrPhone: string;
  isLoading: boolean;
  clientErrors: ClientError[];
  serverError: string;
  externalLoginLinks: LoginLink[],
  loginLink: string;
  startJoin: () => void;
  setEmailOrPhone: (emailOrPhone: string) => void;
}


const Join: React.FC<JoinParameters> = ({ emailOrPhone, isLoading, clientErrors, serverError, loginLink, externalLoginLinks, setEmailOrPhone, startJoin }) => {
  const translations = useTranslate(["participant-login-email-or-phone-label", "participant-login-join-info", "participant-login-next-label", "participant-login-join-existing-account"]);
  useTurnstile();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    startJoin()
    return false
  }

  const handleChangeEmailOrPhone = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmailOrPhone(e.target.value)
  }

  return (
    <form className="login-action join" onSubmit={handleSubmit}>
      <h3><LocalizedText textKey="participant-login-join-title" /></h3>
      <p dangerouslySetInnerHTML={{ __html: translations["participant-login-join-info"] }} />
      {
        clientErrors.some((ce) => (ce === 'accountExists')) && (
          <p className="error"><LocalizedText textKey="participant-login-join-account-exists" /> <Link to={loginLink}><LocalizedText textKey="participant-login-join-click-here-to-sign-in" /></Link>.</p>
        )
      }
      {
        clientErrors.some((ce) => (ce === 'externalAccountExists')) && (
          <p className="error"><LocalizedText textKey="participant-login-join-account-exists-external" /> <LocalizedText textKey="participant-login-join-click-here-to-sign-in-external" />.</p>
        )
      }
      {
        serverError && (
          <p className="server-error">{serverError}</p>
        )
      }
      <div className="field-group">
        <label className="login-field sr-only" htmlFor="joinEmailOrPhone">{translations["participant-login-email-or-phone-label"]}</label>
        <Input
          onChange={handleChangeEmailOrPhone}
          disabled={isLoading}
          id="joinEmailOrPhone"
          type="text"
          value={emailOrPhone}
          placeholder={translations["participant-login-email-or-phone-label"]}
          autoComplete="username"
          autoFocus={true}
          fullWidth={true}
          htmlAttributes={{
            spellCheck: false,
            autoCorrect: "off",
            onInput: handleChangeEmailOrPhone,
          }}
        />
      </div>
      <div>
        <div id="cf-turnstile" className="cf-turnstile"></div>
        <Button
          onClick={handleSubmit}
          type='submit'
          intent='primary'
          disabled={!isValidEmailOrPhone(emailOrPhone) || isLoading}
          className="primary-action"
          width='100%'
          loading={isLoading}
        >
          <span dangerouslySetInnerHTML={{ __html: translations["participant-login-next-label"] }} />
        </Button>
      </div>

      <p className="sub-action">
        <span dangerouslySetInnerHTML={{ __html: translations["participant-login-join-existing-account"] }} /> <Link to={loginLink}><LocalizedText textKey="participant-login-sign-in-label" /></Link>
      </p>
      <small className="disclaimer"><LocalizedText textKey="participant-login-join-disclaimer" /></small>
      {
        externalLoginLinks?.map((link) => (
          <p
            key={link.Name}
            className="sub-action"
          >
            <a
              href={link.Href}
              className="brand-color login-controls-link"
            >
              <LocalizedText
                textKey="participant-login-join-external"
                values={{ externalIdentityProviderName: link.Name }}
              />
            </a>
          </p>
        ))
      }
    </form>
  )
}

export default Join